'use client';

import React from 'react';
import { SxProps, Popover, InputAdornment } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { SearchStationDetailType } from '@/schemas/SearchStationDetailSchema';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { UseFormReturn } from 'react-hook-form';
import { useLogic } from './logic';
import { CalendarFilter } from './CalendarFilter';

type Props = {
  formMethod: UseFormReturn<SearchStationDetailType>;
  size?: OverridableStringUnion<'small' | 'medium'>;
  sx?: SxProps;
};

export const CalendarFilterField: React.FC<Props> = ({
  formMethod,
  size = 'small',
  sx,
}) => {
  const { anchorEl, handleOpenFilter, handleCloseFilter } = useLogic({});

  return (
    <>
      <MuiTextField
        name={formMethod.register('calendar_filter_condition').name}
        fullWidth
        onClick={handleOpenFilter}
        placeholder="日時を選ぶ"
        size={size}
        sx={sx}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <DateRangeIcon />
            </InputAdornment>
          ),
          readOnly: true,
        }}
      />
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <CalendarFilter formMethod={formMethod} close={handleCloseFilter} />
      </Popover>
    </>
  );
};
